// extracted by mini-css-extract-plugin
export default {"card":"DhcpLeases_card__VdDz0"};